import React from 'react'
import {FlexGrowContent, RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {Close} from '@mui/icons-material'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import styled from 'styled-components'
import {currentMedia} from '../../../../styledComponents/ResponsiveConvenience'
import {
    DialogCloseButton,
    DialogTitleArea,
    DisplayItemDividerDialog,
    PanelArea,
} from '../common/NatResidentAssocWorkReportsCommon'
import moment from 'moment/moment'
import {NatResidentMergedReportFileComponent} from './NatResidentMergedReportFileComponent'

interface Props {
    condominiumCd: string
    assocCd: string
    currentMoment: moment.Moment
    targetYearMonth: string
    totalFileSizeKB: number
    onMergedFileByYearMonthClick:
        (targetYearMonth: string) => Promise<void>
    onClose: () => void
}

export const NatResidentMergedReportFileDialog: React.FC<Props> = props => {
    const {
        currentMoment,
        targetYearMonth,
        totalFileSizeKB,
        onMergedFileByYearMonthClick,
        onClose,
    } = props

    const targetYearMonthText = moment(targetYearMonth, 'YYYYMM').format('YYYY年M月')
    const currentDateText = currentMoment.format('YYYYMMDD')
    const mergedFileName = `${targetYearMonthText}分報告書_${currentDateText}.pdf`

    return (<>
        <PanelArea>
            <DialogTitleArea>
                <RowFlexContainer>
                    <StyleDialogTitle>{targetYearMonthText + '分報告書'}</StyleDialogTitle>
                    <DialogCloseButton onClick={onClose} id={'close'}>
                        <Close fontSize={'large'} style={{color: `${Colors.AccentDark}`}}/>
                    </DialogCloseButton>
                </RowFlexContainer>
            </DialogTitleArea>
            <DisplayItemDividerDialog/>
            <NatResidentMergedReportFileComponent
                mergeFileType={`${targetYearMonthText}分の報告書`}
                currentMoment={currentMoment}
                onMergedFileClick={() => onMergedFileByYearMonthClick(targetYearMonth)}
                totalFileSizeKB={totalFileSizeKB}
                mergedFileName={mergedFileName}
            />
            <FlexGrowContent/>
        </PanelArea>
    </>)
}

const StyleDialogTitle = styled.div`
  font-size: ${FontSize.Accent};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
  line-height: 30px;
  margin: 7px 0 7px 5px;
  ${currentMedia.lessThan('sp')`
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
  `};
`
